import * as React from "react";

import { DatePicker } from "kanopi-components/DatePicker";
import { FormControl } from "kanopi-components/Input";
import { maybe } from "kanopi-components/utils/functional";

import { WidthContainer } from "../../ChatFlow/WidthContainer";
import { DatepickerProps } from "baseui/datepicker";

type DateInputProps = {
  label: string;
  value: DatepickerProps["value"];
  title: string;
  help: string;
  error: string;
  onChange?: (value: string) => void;
  size: DatepickerProps["size"];
};

export function DateInput(props: DateInputProps) {
  const { label, title, help, error, value, onChange, size, ...restProps } = props;

  function handleChange(value: Date) {
    const formattedValue = formatDate(value);
    maybe(onChange)(formattedValue);
  }
  return (
    <WidthContainer size={size}>
      <FormControl label={label} caption={help} error={error} title={title}>
        {/* @ts-expect-error fix types on DatePicker component */}
        <DatePicker size={size} value={value} onChange={handleChange} {...restProps} />
      </FormControl>
    </WidthContainer>
  );
}

export function formatDate(value: Date) {
  if (!value) return value;
  const year = value.getFullYear();
  const month = `${value.getMonth() + 1}`.padStart(2, "0");
  const day = `${value.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
}
